module.exports = __webpack_public_path__ + "static/media/Milex-Gellhorn-Pessary-Instructions-for-Use@3x.c427f883.jpg";